import React, { useEffect, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { withRouter  } from 'react-router-dom';
import moment from "moment";
import 'moment/locale/ru';
import { styles } from "../../../containers/goods/styles";
import { fetchPlannedRevenue, updatePlannedRevenue } from "../../../action/cassa";
import Loader from "../../utils/Loader";
import { fetchFilials } from "../../../action/handbook";
import ErrorContainer from "../../utils/ErrorContainer";
import BackButton from "../../utils/BackButton";
import swal from 'sweetalert';
import { utils, writeFileXLSX } from 'xlsx';
import { formatNumberWithSpaces, parseNumToFixed, roundToFixed } from "../../../utils/common";
import { setActiveModalAction } from "../../../action";
import Switch from "../../utils/Switch";

const months = [ 'Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь' ];

function EditPlannedRevenue({ history, match }) {
    const initData = useSelector(state => state.cassa.plannedRevenue);
    const points = useSelector(state => state.handbook.filials);
    const pointsCount = useSelector(state => state.handbook.count.filials);
    const loadingPoints = useSelector(state => state.loaders.filials);
    const loadingPlannedRevenue = useSelector(state => state.loaders.plannedRevenue);
    const loading = loadingPoints || loadingPlannedRevenue;
    const user = useSelector(state => state.user.info);
    const [show, setShow] = useState(false);
    const originalPlanRef = useRef(null);

    const [totalMonthSum, setTotalMonthSum] = useState(0);
    const [multipliers, setMultipliers] = useState({
        fri: 1,
        sat: 1,
        sun: 1,
    })
    const [lockedDates, setLockedDates] = useState({});

    const [data, setData] = useState({...initData});

    const dispatch = useDispatch();

    useEffect(() => {
        const getData = async (id) => {
            const response = await dispatch(fetchPlannedRevenue(id));
            if (response && response.id) return setData({...response});
            return history.goBack();
        }
        if (!data || isEmpty(data)) {
            const id = match.params.id;
            if (!id) return history.goBack();
            getData(id);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [match.params.id, dispatch, history]);

    useEffect(() => {
        const getData = async () => { await dispatch(fetchFilials(null, true)) }
        if (isEmpty(points) || points.length < pointsCount) getData();
    }, [points, pointsCount, dispatch]);

    const renderPointLabel = (point) => {
        if (!point) return 'Филиал не определен';
        const cityName = point.city ? point.city.name : 'Город не указан';
        return `${cityName}, ${point.street || 'Улица не указана'} ${point.house || ''}`
    };
    
    useEffect(() => {
        if (originalPlanRef.current === null && initData && initData.plan) {
            originalPlanRef.current = { ...initData.plan };
        }
    }, [initData]);

    const date = moment(data.startOfMonthDate);
    const dateTitle = `${months[date.month()]} ${date.year()}`
    const point = points.find((p) => p.id === data.pointId);
    const pointName = renderPointLabel(point);

    if (loading) return(
        <div className='kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid'>
            <div style={styles.tableLoading}><Loader text='Загружаю данные'/></div>
        </div>
    );

    const onRefresh = async () => {
        const id = match.params.id;
        if (!id) return history.goBack();
        const response = await dispatch(fetchPlannedRevenue(id));
        if (response && response.id) return setData({...response});
        return history.goBack();
    }

    const onExport = async () => {
        const dates = getPlanDates();

        const getValuePlan = (date) => {
            const plan = data.plan || {};
            if (isEmpty(plan)) return 0;
            return parseNumToFixed(plan[date]) || 0;
        }
        
        const plan = data.plan || {};
        dates.forEach((currentDate) => {
            plan[currentDate] = getValuePlan(currentDate);
        });

        const exportData = Object.entries(plan).map(([currentDate, value]) => {
            return {
                'Филиал': pointName,
                'Дата': currentDate,
                'День недели': moment(currentDate, 'DD.MM.YYYY').locale('ru').format('dddd'),
                'Плановая выручка': value,
            }
        });

        const totalSum = Object.values(plan).reduce((acc, value) => {
            return acc += Number(value);    
        }, 0);

        exportData.push({
            'Филиал': 'ИТОГО',
            'Плановая выручка': roundToFixed(totalSum),
        });

        const ws = utils.json_to_sheet(exportData);
        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, dateTitle);
        writeFileXLSX(wb, `Плановая выручка ${pointName} ${dateTitle}.xlsx`);
    }

    const onOpenModal = (field) => (e) => {
        e.stopPropagation();
        dispatch(setActiveModalAction({ field: field, value: true }));
    };

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Плановая выручка</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"/>
                        <h3 className="kt-subheader__title">{pointName}</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"/>
                        <h3 className="kt-subheader__title">{dateTitle}</h3>
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"/>
                        </button>
                        <span className="kt-subheader__separator kt-subheader__separator--v"/>
                        <h3 className="kt-subheader__title">Быстрое заполнение</h3>
                        <div style={{ marginTop:'5px', transform: 'scale(0.9)', transformOrigin: 'bottom' }}>
                            <Switch
                            style={{ transform: 'scale(0.1)' }}
                            onChange={(e) => setShow(!show)}
                            checked={show}
                            />
                        </div>
                    </div>
                    <div className="d-flex" style={{ alignItems: 'center' }}>
                        {!isEmpty(data.changeLog) && <button  onClick={onOpenModal('changeLogPlannedRevenue')} className="btn btn-secondary btn-icon-sm"> История изменений </button>}
                        <button onClick={onExport} className="btn btn-dark btn-icon-sm">Экспорт</button>
                        <BackButton />
                    </div>
                </div>
            </div>
        );
    }

    const getPlanDates = () => {
        const dates = [];
        const end = date.clone().endOf('month');
        let current = date.clone();
        while (current <= end) {
            dates.push(current.format('DD.MM.YYYY'));
            current.add(1, 'day');
        }
        return dates;
    }

    const onChangeInputPlan = (currentDate) => (e) => {
        let value = parseNumToFixed(e.target.value);
        if (value === '') value = 0;

        const updated = {...data};
        const plan = updated.plan || {};

        if (value === plan[currentDate]) return;
        
        plan[currentDate] = value;
        updated.plan = plan;
        setData(updated);
    }

    const handleMultiplierChange = (field) => (e) => {
    let value = e.target.value;
    if (isNaN(value) || value < 0.1){
        value = 0.1;
    } else {
        value = Math.round(value * 10) / 10;
    }
    setMultipliers(prev => ({
        ...prev,
        [field]: Number(value)
    }));
    };

    const toggleLock = (date) => {
    setLockedDates((prev) => ({
        ...prev,
        [date]: !prev[date],
    }));
    };

    const onApplyMonthTotalSum = () => {
        if (totalMonthSum <= 0) return;

        const dates = getPlanDates();
        let totalWeight = 0;
        let distributedSum = 0;

        dates.forEach((currentDate) => {
            if (lockedDates[currentDate]) return;
            const dayOfWeek = moment(currentDate, 'DD.MM.YYYY').locale('ru').isoWeekday();
            let weight = 1;
            if (dayOfWeek === 5) weight = multipliers.fri;
            else if (dayOfWeek === 6) weight = multipliers.sat;
            else if (dayOfWeek === 7) weight = multipliers.sun;

            totalWeight += weight;
        });

        if (totalWeight === 0) return;
        const updated = { ...data };
        const plan = updated.plan || {};
        const resultSum = totalMonthSum - dates.reduce((sum, d) => lockedDates[d] ? sum + (plan[d] || 0) : sum, 0);
        if (resultSum <= 0) return swal({
            title: "Плановая выручка за месяц меньше суммы заблокированных значений",
            text: 'Увеличьте плановую выручку за месяц или уменьшите суммы для отдельных дней и повторите попытку',
            icon: "error",
            dangerMode: true,
            button: "Ок",
        })
        
        dates.forEach((currentDate) => {
            if (lockedDates[currentDate]) return;
            const dayOfWeek = moment(currentDate, 'DD.MM.YYYY').locale('ru').isoWeekday();
            let weight = 1;
            if (dayOfWeek === 5) weight = multipliers.fri;
            else if (dayOfWeek === 6) weight = multipliers.sat;
            else if (dayOfWeek === 7) weight = multipliers.sun;

            const share = Math.floor((weight / totalWeight) * resultSum);
            plan[currentDate] = parseNumToFixed(share);
            distributedSum += share;            
        });
        const remainder = resultSum - distributedSum;
        const firstUnlocked = dates.find((d) => !lockedDates[d]);
        plan[firstUnlocked] += remainder;
        updated.plan = plan;
        setData(updated);
    }

    const renderBody = () => {
        const dates = getPlanDates();

        const getValuePlan = (date) => {
            const plan = data.plan || {};
            if (isEmpty(plan)) return 0;
            return +parseNumToFixed(plan[date]) || 0;
        }
        
        return (
            <>
                {show && <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '600px', margin: '20px' }}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontWeight: 400, color: 'black', width: '240px' }}> Плановая выручка за месяц: </span>               
                        <input
                        type="number"
                        step={1}
                        className="form-control"
                        style={{ width: '200px' }}
                        onFocus={(e) => e.target.select()}
                        onChange={(e) => setTotalMonthSum(Number(e.target.value) || 0)}
                        />
                        <button className="btn btn-primary btn-icon-sm" onClick={onApplyMonthTotalSum}> Применить </button>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px' }}>
                        <span style={{ fontWeight: 400, color: 'black', width: '205px' }}>Множители для выходных:</span>
                        <span style={{ fontWeight: 400, color: 'black' }}> Пт </span>
                        <span style={{ fontWeight: 400, color: 'black', fontSize: '15px' }}>х</span>
                        <input
                        type="number"
                        step={0.1}
                        value={multipliers.fri}
                        onChange={handleMultiplierChange('fri')}
                        className="form-control"
                        style={{ width: '65px' }}
                        onFocus={(e) => e.target.select()}
                        />                        
                        <span style={{ fontWeight: 400, color: 'black' }}> Сб </span>
                        <span style={{ fontWeight: 400, color: 'black', fontSize: '15px' }}>х</span>
                        <input
                        type="number"
                        step={0.1}
                        value={multipliers.sat}
                        onChange={handleMultiplierChange('sat')}
                        className="form-control"
                        style={{ width: '65px' }}
                        onFocus={(e) => e.target.select()}
                        />                        
                        <span style={{ fontWeight: 400, color: 'black' }}> Вс </span>
                        <span style={{ fontWeight: 400, color: 'black', fontSize: '15px' }}>х</span>
                        <input
                        type="number"
                        step={0.1}                        
                        value={multipliers.sun}
                        onChange={handleMultiplierChange('sun')}
                        className="form-control"
                        style={{ width: '65px' }}
                        onFocus={(e) => e.target.select()}
                        />                     
                    </div>
                    
                </div>}
                <div className="kt-datatable kt-datatable--default kt-datatable--brand kt-datatable--loaded">
                    <table className="kt-datatable__table" style={{ width: 'auto' }}>
                        <thead className="kt-datatable__head" style={{ width: 'auto' }}>
                            <tr className="kt-datatable__row" style={{ width: 'auto' }}>
                                <th className="kt-datatable__cell" style={{ width: '200px' }}>
                                    <span style={{ fontWeight: 300, color: 'black' }}>Дата</span>
                                </th>
                                <th className="kt-datatable__cell" style={{ width: '200px' }}>
                                    <span style={{ fontWeight: 300, color: 'black' }}>День недели</span>
                                </th>
                                <th className="kt-datatable__cell" style={{ width: '200px' }}>
                                    <span style={{ fontWeight: 300, color: 'black' }}>Плановая выручка</span>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="kt-datatable__body" style={{ width: 'auto' }}>
                            {!isEmpty(dates) && dates.map((currentDate) => (
                                <tr className="kt-datatable__row" style={{ width: 'auto', backgroundColor: lockedDates[currentDate] ? '#f5f5f5' : 'inherit' }}>
                                    <td className="kt-datatable__cell" style={{ width: '200px' }}>
                                        <span style={{ fontWeight: 300, color: 'black' }}>{currentDate}</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '200px' }}>
                                        <span style={{ fontWeight: 300, color: 'black' }}>{moment(currentDate, 'DD.MM.YYYY').locale('ru').format('dddd')}</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '200px' }}>
                                        <input
                                        type="text"
                                        step={1}
                                        className="form-control"
                                        value={getValuePlan(currentDate)}
                                        onFocus={(e) => e.target.select()}
                                        onChange={
                                            onChangeInputPlan(currentDate)
                                        }
                                        />
                                    </td>
                                    <td>
                                        <button className="btn btn-icon btn-sm" onClick={() => toggleLock(currentDate)} aria-label={lockedDates[currentDate] ? 'Разблокировать' : 'Заблокировать'}>
                                            <i className={lockedDates[currentDate] ? 'la la-unlock' : 'la la-unlock-alt'} style={{color: lockedDates[currentDate] ? 'red' : 'inherit'}} aria-hidden="true" />
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            {!isEmpty(dates) &&
                                <tr className="kt-datatable__row" style={{ width: 'auto', backgroundColor: '#cfcfcf61   ' }}>
                                    <td className="kt-datatable__cell" style={{ width: '200px' }}>
                                        <span style={{ fontWeight: 300, color: 'black' }}>ИТОГО</span>
                                    </td>
                                    <td className="kt-datatable__cell" style={{ width: '200px' }}></td>
                                    <td className="kt-datatable__cell" style={{ width: '200px' }}>
                                        <span style={{ fontWeight: 300, color: 'black' }}>
                                            {formatNumberWithSpaces(roundToFixed(dates.reduce((acc, currentDate) => {
                                                return acc += Number(getValuePlan(currentDate));
                                            }, 0)))}
                                        </span>
                                    </td>
                                </tr>

                            }
                        </tbody>
                    </table>
                </div>
            </>
        );
    }

    const onSubmit = async () => {
        const dates = getPlanDates();
        const currentPlan = data.plan || {};
        const oldChangeLog = data.changeLog || {};
        const username = user ? user.name ? user.name : user.username : null;
        const logDateKey = moment().format('DD.MM.YYYY');
        const dailyLog = [];
        
        dates.forEach((date) => {
            const oldValue = originalPlanRef.current ? originalPlanRef.current[date] : '';
            const newValue = currentPlan[date];
            
            if (oldValue !== newValue) {
                dailyLog.push({
                    field: date,
                    prevValue: oldValue,
                    newValue: newValue,
                    user: username,
                    dateTime: moment().format('DD.MM.YYYY HH:mm:ss')
                });
            }
        });

        let updatedChangeLog = { ...oldChangeLog  };
        if (dailyLog.length > 0) {
            updatedChangeLog[logDateKey] = [
            ...(updatedChangeLog[logDateKey] || []),
            ...dailyLog 
            ];
        }
        
        const getValuePlan = (date) => {
            const plan = data.plan || {};
            if (isEmpty(plan)) return 0;
            return +parseNumToFixed(plan[date]) || 0;
        }
        
        const plan = data.plan || {};
        dates.forEach((currentDate) => {
            plan[currentDate] = getValuePlan(currentDate);
        });

        const sendedData = {...data};
        sendedData.plan = currentPlan;
        sendedData.changeLog = updatedChangeLog;
               
        const result = await dispatch(updatePlannedRevenue(sendedData));
        if (result) return swal({
            title: "Сохранено",
            text: "Данные успешно сохранены",
            icon: "success",
            timer: 1000,
            buttons: false,
        }).then(() => history.goBack());
    }

    return (
        <>
            {renderSubHeader()}
            <div className="kt-container kt-container--fluid  kt-grid__item kt-grid__item--fluid">                    
                <div className="kt-portlet">
                        <div className="kt-portlet__body kt-portlet__body--fit">
                            {renderBody()}
                        </div>
                        <ErrorContainer field="plannedRevenue" style={{ margin: '0 20px 20px' }} hasCloseButton={true}/>
                        <div className="kt-portlet__foot">
                            <div className="kt-form__actions">
                                <button className="btn btn-primary" onClick={onSubmit}>
                                    Сохранить
                                </button>
                            </div>
                        </div>
                </div>
                </div>
        </>
    );
}

export default withRouter(EditPlannedRevenue);